import React from 'react';

import { getLang, getBaseUrl} from '../../../utils';

import { useTranslation } from "react-i18next";
// import PropTypes from 'prop-types';

export const Packs = ({ ...props }) => {
    const { t, i18n } = useTranslation(['summary', 'general']);
    //const lang = getLang();

    const shortLang = getLang() === 'en' ? 'e' : 'f';

    return (
        <>
            <div className="mz-bg--101010">
                <div className="mz-spacer-m mz-spacer"></div>
                <div className="mz-circle-callout mz-circle-callout--warranty">
                    <div className="mz-image mz-circle-callout__top-logo">
                        <img src={`https://mazda.ca/globalassets/mazda-canada/c65_mazdaunlimitedlogo_neg_${shortLang}_new.png`} alt="Mazda Unlimited Mileage Warranty."/>
                    </div>
                    <div className="mz-container mz-four-col-grid">
                        <div className="mz-circle-callout-wrapper ">
                            <div className="image">
                                <div className="mz-image   ">
                                    <img src="https://mazda.ca/contentassets/3b14f54f8aa6495999c6e6d1e1477959/c63_unlmited_newvehicle.png" alt="White car icon."/>
                                </div>    
                            </div>
                            <div className="top-label">
                                <h6 className="text--grey"></h6>
                            </div>
                            <div className="big-text">
                                <h4 className="text--white">{t("wrnty_newVeh")}</h4>
                            </div>
                            <div className="text text--grey2">
                                <h6 className="text--white">{t("wrnty_unlimited")}</h6>
                            </div>
                        </div>
                        <div className="mz-circle-callout-wrapper ">
                            <div className="image">
                                <div className="mz-image   ">
                                    <img src="https://mazda.ca/contentassets/ca3ba1ddd7e84ecc9ee1ba3ea10d11d3/c63_unlmited_roadside.png" alt="White road icon."/>
                                </div>    
                            </div>
                            <div className="top-label">
                                <h6 className="text--grey"></h6>
                            </div>
                            <div className="big-text">
                                <h4 className="text--white">{t("wrnty_roadside")}</h4>
                            </div>
                            <div className="text text--grey2">
                                <h6 className="text--white">{t("wrnty_mileage")}</h6>
                            </div>
                        </div>
                        <div className="mz-circle-callout-wrapper ">
                            <div className="image">
                                <div className="mz-image   ">
                                    <img src="https://mazda.ca/contentassets/b2c41975a22049409c47e9ab7f278f4d/c63_unlmited_powertrain.png" alt="White powertrain icon."/>
                                </div>    
                            </div>
                            <div className="top-label">
                                <h6 className="text--grey"></h6>
                            </div>
                            <div className="big-text">
                                <h4 className="text--white">{t("wrnty_powertrain")}</h4>
                            </div>
                            <div className="text text--grey2">
                                <h6 className="text--white">{t("wrnty_unlimited")}</h6>
                            </div>
                        </div>
                        <div className="mz-circle-callout-wrapper ">
                            <div className="image">
                                <div className="mz-image   ">
                                    <img src="https://mazda.ca/contentassets/5ac1baf08c5b43cd9230b7495f35906a/c63_unlmited_antiperforation.png"  alt="White shield icon."/>
                                </div>    
                            </div>
                            <div className="top-label">
                                <h6 className="text--grey"></h6>
                            </div>
                            <div className="big-text">
                                <h4 className="text--white">{t("wrnty_perforation")}</h4>
                            </div>
                            <div className="text text--grey2">
                                <h6 className="text--white">{t("wrnty_unlimited")}</h6>
                            </div>
                        </div>   
                    </div>
                </div>
                <a className="mz-btn  mz-btn--primary mz-btn--white mz-btn--center" href={t("wrnty_href")} target="_self" data-link-type="internal" data-link-name="View Warranty Details" data-link-url="/en/mazda-owners/Overview/warranty/"><span>{t("wrnty_cta")}</span></a>
                <div className="mz-spacer-m mz-spacer mz-bg--101010"></div>
            </div>
            <div className="mz-spacer-s mz-spacer"></div>
        </>
    )
};